// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__kh9k1","addWidgetButton":"Header_addWidgetButton__2qoeQ","dashboardTabs":"Header_dashboardTabs__Tetpv","active":"Header_active__16t-S"};